import { getContext, setContext } from 'svelte'
import Cookies from 'js-cookie'
import { ResultSync } from '$lib/utils/result'

const CONTEXT = Symbol('ANALYTICS')

export function createAnalyticsContext(...args: ConstructorParameters<typeof AnalyticsContext>): AnalyticsContext {
      return setContext(CONTEXT, new AnalyticsContext(...args))
}

export function getAnalyticsContext(): AnalyticsContext {
      return getContext(CONTEXT)
}

class AnalyticsContext {
      consent = $state({}) as { [keyof: string]: any }
      consentRequired = $state(false)
      key: string

      constructor({ key }: { key: string } = { key: 'null' }) {
            this.key = key
            return this
      }

      loadUserPrefrences() {
            const data = Cookies.get(this.key)
            if (!data) {
                  return this
            }

            const { value, Err } = ResultSync(() => {
                  const _data = reverseString(data)
                  return JSON.parse(atob(_data))
            })

            if (Err) {
                  return this
            }

            this.consent = value
            return this
      }

      saveUserPreferences() {
            const { value, Err } = ResultSync(() => {
                  return btoa(JSON.stringify(this.consent))
            })

            if (Err) return this
            const _value = reverseString(value)
            Cookies.set(this.key, _value, {
                  expires: 60,
            })
            return this
      }

      checkConsent() {
            if (Object.keys(this.consent).length == 0) this.requireConsent()
            return this
      }

      requireConsent() {
            this.consentRequired = true
            return this
      }

      setConsent(args: any) {
            const consent = {
              gtag: gtagConsent(args),
              sklik: sklikConsent(args),
              pixel: pixelConsent(args),
            }
            this.consent = consent
            this.consentRequired = false
            this.saveUserPreferences()
            return this
      }
}

function reverseString(string: string) {
      return string.split('').reduceRight((a, b) => a + '' + b)
}

function gtagConsent(consent: any) {
      let gtag = {
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            ad_storage: 'denied',
            analytics_storage: 'denied',
      }
      if (consent.marketing) {
            gtag = {
                  ...gtag,
                  ad_user_data: 'granted',
                  ad_personalization: 'granted',
                  ad_storage: 'granted',
            }
      }
      if (consent.analytics) {
            gtag = {
                  ...gtag,
                  analytics_storage: 'granted',
            }
      }

      return gtag
}

function sklikConsent(consent: any) {
  let sklik = { consent: null } as { consent: 1|null}
  if( consent.marketing ) sklik.consent = 1

  return sklik
}

function pixelConsent(consent: any) {
  let pixel = { consent: null } as { consent: 1|null}
  if( consent.marketing ) pixel.consent = 1
  return pixel
}